import {
  billingHistoryTableAssociateColumns,
  billingHistoryTableColumns,
} from '../../../constants/tableColumns';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useBillingHistoryContext } from '../../../contexts/BillingHistoryProvider';
import { User } from '../../../types/users';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import CreateBillAction from './CreateBillAction';

const ShowAllBillingInfo = () => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();
  const { billingHistoryList, isError, isLoading, isSuccess } =
    useBillingHistoryContext();

  // rendering show all billing info section component here
  return (
    <>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        <section>
          <PageHeader headerText='Billing History' />

          <AcademiaTable
            data={billingHistoryList}
            columns={
              (currentUser as User)?.role_name === 'Admin'
                ? billingHistoryTableColumns
                : billingHistoryTableAssociateColumns
            }
            notFoundMessage='No billing history found!'
            tableToolbarComponent={
              (currentUser as User)?.role_name === 'Admin' ? (
                <CreateBillAction />
              ) : undefined
            }
          />
        </section>
      ) : isError ? (
        <AcademiaNotFound message='Failed to load billing history data!!' />
      ) : null}
    </>
  );
};

export default ShowAllBillingInfo;
